import React from 'react';
import './Careers.css';

const Careers = () => {
  return (
    <div className="careers-page">
      {/* Hero Section */}
      <div className="careers-hero">
        <div className="careers-hero-content">
          <h1>Join Our Team</h1>
          <p>Build the future of e-commerce with us</p>
        </div>
      </div>

      <div className="careers-container">
        <div className="careers-content">
          <div className="careers-section">
            <h2>Why Work With Us?</h2>
            <div className="benefits-grid">
              <div className="benefit-card">
                <div className="benefit-icon">🚀</div>
                <h3>Growth Opportunities</h3>
                <p>Fast-paced environment with endless learning possibilities</p>
              </div>
              <div className="benefit-card">
                <div className="benefit-icon">💼</div>
                <h3>Flexible Work</h3>
                <p>Remote work options and flexible schedules</p>
              </div>
              <div className="benefit-card">
                <div className="benefit-icon">🏥</div>
                <h3>Great Benefits</h3>
                <p>Health insurance, paid time off, and more</p>
              </div>
              <div className="benefit-card">
                <div className="benefit-icon">👥</div>
                <h3>Amazing Team</h3>
                <p>Work with talented and passionate individuals</p>
              </div>
            </div>
          </div>

          <div className="careers-section">
            <h2>Open Positions</h2>
            <div className="positions-list">
              <div className="position-card">
                <h3>Frontend Developer</h3>
                <p className="position-location">Remote / Full-time</p>
                <p className="position-description">Join our team to build amazing user experiences with React and modern web technologies.</p>
                <button className="apply-btn">Apply Now</button>
              </div>
              <div className="position-card">
                <h3>Backend Developer</h3>
                <p className="position-location">Remote / Full-time</p>
                <p className="position-description">Help us scale our platform with robust backend systems and APIs.</p>
                <button className="apply-btn">Apply Now</button>
              </div>
              <div className="position-card">
                <h3>Product Manager</h3>
                <p className="position-location">Remote / Full-time</p>
                <p className="position-description">Drive product strategy and lead cross-functional teams to deliver amazing products.</p>
                <button className="apply-btn">Apply Now</button>
              </div>
            </div>
          </div>

          <div className="careers-section">
            <h2>How to Apply</h2>
            <div className="application-steps">
              <div className="step">
                <div className="step-number">1</div>
                <h3>Submit Application</h3>
                <p>Send us your resume and cover letter</p>
              </div>
              <div className="step">
                <div className="step-number">2</div>
                <h3>Initial Screening</h3>
                <p>We'll review your application and get back to you</p>
              </div>
              <div className="step">
                <div className="step-number">3</div>
                <h3>Interview Process</h3>
                <p>Meet with our team and discuss opportunities</p>
              </div>
              <div className="step">
                <div className="step-number">4</div>
                <h3>Welcome Aboard</h3>
                <p>Join our team and start your journey</p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Careers; 